// import { UserType } from "@/interfaces";
import { TeamType, UserType } from "@/interfaces";
import axios from "axios";
import { create } from "zustand";

type GenericStoreType = {
  assignees: { users: UserType[]; teams: TeamType[] };
  fetchAssignees: () => void;
  reset: () => void;
};

const useGenericStore = create<GenericStoreType>((set) => ({
  assignees: { users: [], teams: [] },
  fetchAssignees: async () => {
    try {
      const users = await axios.get(`/api/users/?isActive=true`);
      const teams = await axios.get(
        `/api/teams/?isActive=true&hasMembers=true`
      );
      set({ assignees: { users: users.data, teams: teams.data } });
      return { users: users.data, teams: teams.data };
    } catch (error) {
      console.error(error);
      return error;
    }
  },
  reset: () => {
    set(() => ({ assignees: { users: [], teams: [] } }));
  },
}));

export { useGenericStore };
